import underlay from './modules/helpers/Underlay';

/**
 *  Modal App class
 */

class ModalApp {
  /**
   *  Constructor
   */
  constructor() {
    this.container = document.querySelector('.js-modal-container');
    this.activeModal = false;
    this.enableClose = true;

    if (!this.container) { return; }

    this.init = this.init.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onContainerClick = this.onContainerClick.bind(this);

    this.onDocumentReady(this.init);
  }

  // eslint-disable-next-line class-methods-use-this
  onDocumentReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  init() {
    this.container.addEventListener('click', this.onContainerClick);

    this.closeButton = document.createElement('button');
    this.closeButton.classList.add('modal__button-close');
    this.closeButton.innerHTML = 'Sluiten';
    this.closeButton.addEventListener('click', this.closeModal);

    this.showModalOnLoad();
  }

  openModal(id, enableClose = true, external = false) {
    const modal = document.querySelector(`.js-modal[data-modal-id="${id}"]`);

    /** append the modal to the modal container, so we can generate modals everywhere */
    if (external) {
      const modalHolder = document.querySelector('.js-modal-container.modal-container');
      modalHolder.appendChild(modal);
    }

    if (modal) {
      if (this.activeModal) {
        const activeModal = document.querySelector(`.js-modal[data-modal-id="${this.activeModal}"]`);
        if (activeModal) {
          activeModal.classList.remove('is--active');
        }
      }

      if (enableClose) {
        modal.prepend(this.closeButton);
        this.closeButton.style.display = 'block';
      } else {
        this.closeButton.style.display = 'none';
      }

      this.enableClose = enableClose;

      this.container.classList.add('is--active');
      modal.classList.add('is--active');
      underlay.show(11);

      this.activeModal = id;
    }
  }

  onContainerClick(e) {
    if (!this.enableClose) { return; }

    if (e.target === this.container) {
      this.closeModal();
    }
  }

  closeModal() {
    if (this.activeModal) {
      const activeModal = document.querySelector(`.js-modal[data-modal-id="${this.activeModal}"]`);
      if (activeModal) {
        activeModal.classList.remove('is--active');
      }
    }

    this.activeModal = false;
    this.container.classList.remove('is--active');
    underlay.hide();
  }

  showModalOnLoad() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const showModal = urlParams.get('show-modal')

    if (showModal) {
      this.openModal(showModal);
    }
  }
}

window.modalApp = new ModalApp();
